import {Box, Grid, Divider} from "@mui/material";
import aboutImage from "../assets/images/about/giovanna-losco.jpg";
import logo1 from "../assets/images/about/logo-aeaa.png";
import logo2 from "../assets/images/about/logo-ariacs.jpg";
import {useEffect, useState} from "react";
import {loadMarkdown} from "../utils/loadMarkdown";
import MuiMarkdown from "../components/MuiMarkdown";

export default function About({ lang }) {
    const [intro, setIntro] = useState("");
    const [bio, setBio] = useState("");
    const [team, setTeam] = useState("");

    useEffect(() => {
        loadMarkdown("about", lang, "intro").then(setIntro);
    }, [lang, intro]);

    useEffect(() => {
        loadMarkdown("about", lang, "bio").then(setBio);
    }, [lang, bio]);

    useEffect(() => {
        loadMarkdown("about", lang, "team").then(setTeam);
    }, [lang, team]);

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: "flex-start",
                    gap: 4,
                }}
            >
                {intro !== null && intro !== "" && (
                    <>
                        {/* Immagine */}
                        <Box
                            component="img"
                            src={aboutImage}
                            alt="Giovanna Losco"
                            sx={{
                                maxWidth: {xs: "100%", md: "360px"},
                                borderRadius: 2,
                                boxShadow: 3,
                                display: "block",
                                margin: {xs: "0 auto", md: 0}, // centrata solo su mobile
                            }}
                        />

                        {/* Testo */}
                        <Box sx={{width: "100%"}} textAlign="left">
                            <MuiMarkdown>{intro}</MuiMarkdown>
                        </Box>
                    </>
                )}
            </Box>
            <Divider sx={{mt: {sm: 3}, mb: {xs: 3}}}/>
            {/* BIO Section */}
            <Box textAlign="left">
                {bio !== null && bio !== "" && <MuiMarkdown>{bio}</MuiMarkdown>}
            </Box>
            <Divider sx={{mb: {xs: 3}}}/>
            {/* TEAM Section */}
            <Box textAlign="left">
                {team !== null && team !== "" && <MuiMarkdown>{team}</MuiMarkdown>}
            </Box>
            <Divider sx={{mb: {xs: 3}}}/>
            {/* Loghi in fondo */}
            <Grid container spacing={4} justifyContent="center" alignItems="center">
                <Grid>
                    <Box
                        component="img"
                        src={logo1}
                        alt="Logo 1"
                        sx={{width: "100%", maxHeight: 80, objectFit: "contain"}}
                    />
                </Grid>
                <Grid>
                    <Box
                        component="img"
                        src={logo2}
                        alt="Logo 2"
                        sx={{width: "100%", maxHeight: 80, objectFit: "contain"}}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}